import React from 'react'
import { Calendar, DateObject } from "react-multi-date-picker"
import { datesAreOnSameDay } from '../../config/dateFormatting';
import { handleChangeDateObject } from '../../utils/calendarDateHelpers';

export const MultiDateCalendarPicker = ({minDate, selectedDate, setParentDate} : {minDate:Date, selectedDate: Date, setParentDate: React.Dispatch<React.SetStateAction<any>>}) => {
    return (
        <Calendar
            currentDate={new DateObject()}
            multiple={false}
            value={selectedDate} 
            onChange={(e) => handleChangeDateObject(e,setParentDate)}
            minDate={minDate}
            weekStartDayIndex={1}
            showOtherDays={false}
            mapDays={({ date }) => {
                // Styling of today
                if(datesAreOnSameDay(date.toDate(), new DateObject().toDate())){
                    return {
                        style: { background: "#6178ed7c", color:'white' },
                        id: "today-calendar-date",
                        className: "calendar-date",
                    }
                }
                
                // Styling of weekends
                let isWeekend = [0, 6].includes(date.weekDay.index)
                if (isWeekend) return {
                    disabled: true,
                    style: { color: "#ccc" },
                    className: "calendar-date",
                    onClick: () => alert("Weekends are disabled")
                }

                // Identifiers for date spans
                return{
                    className: "calendar-date",
                }
            }}
        />
    );
}